const getContentProps = content => ({ dangerouslySetInnerHTML: { __html: content } })

export default getContentProps